webpackJsonp([15400075347947],{

/***/ "./node_modules/hoist-non-react-statics/index.js":
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/builds/thegridresistance/public-web/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/builds/thegridresistance/public-web/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/builds/thegridresistance/public-web/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/builds/thegridresistance/public-web/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/builds/thegridresistance/public-web/node_modules/babel-preset-stage-0/lib/index.js\",\"/builds/thegridresistance/public-web/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/privacy-policy.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPolicyPage = function PrivacyPolicyPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Privacy Policy for The Grid'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'At The Grid, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by The Grid and how we use it.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'The domains used by The Grid are the-grid.org and subdomains to the same domain. The rest of this document will refer to these as the-grid.org.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us through email at contact@the-grid.org.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Where information is processed'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'The Grid is based in Sweden. No matter where you are located, you consent to the processing and transferring of your information in and to Sweden and other countries. The laws of Sweden and other countries governing data collection and use may not be as comprehensive or protective as the laws of the country where you live.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Our use of your information'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We use the information you provide in a manner that is consistent with this Privacy Policy. If you provide information for a certain reason, we may use the information in connection with the reason for which it was provided. For instance, if you contact us by email, we will use the information you provide to answer your question or resolve your problem. Also, if you provide information in order to obtain access to the Services, we will use your information to provide you with access to such services and to monitor your use of such services. We may also use your information collected through the Services to help us improve the content and functionality of the Services, to better understand our users and to improve the Services. We may use this information to contact you in the future to tell you about services we believe will be of interest to you. If we do so, each communication we send you will contain instructions permitting you to "opt-out" of receiving future marketing communications. In addition, if at any time you wish not to receive any future communications or you wish to have your name deleted from our mailing lists, please contact us as indicated below.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Security'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We take reasonable steps to protect the information provided via the Services from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or email transmission is ever fully secure or error free. In particular, email sent to or from the Services may not be secure. Therefore, you should take special care in deciding what information you send to us via email. Please keep this in mind when disclosing any information via the Internet.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Cookies'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Like any other website, the-grid.org uses \u2018cookies\u2019. These cookies are used to store information including visitors\u2019 preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users\u2019 experience by customizing our web page content based on visitors\u2019 browser type and/or other information.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Log files'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'The Grid follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this as a part of hosting services\u2019 analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. The purpose of the information is for analyzing trends, administering the site, tracking users\u2019 movement on the website, and gathering demographic information.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Statistics'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Aggregations and statistics may be shared from time to time, but we will not share specific agents statistics outside our community.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Our legal bases for handling your personal data'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'The laws in some jurisdictions require us to tell you about the legal ground they rely on to use or disclose your personal data. To the extent those laws apply, our legal grounds are as follows:'
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'To honor our contractual commitments to you: For example, we handle personal data on this basis to create your account and provide our Services.'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Legitimate interests:',
	                    _react2.default.createElement('br', null),
	                    'In many cases, we handle personal data on the grounds that it furthers our legitimate interests in ways that are not overridden by the interests or fundamental rights and freedoms of the affected individuals:'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'This includes:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Providing a safe and enjoyable user experience;'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Customer service;'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Marketing, e.g. sending emails or other communications to let you know about new features;'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Protecting our users, personnel, and property;'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Analyzing and improving our Service, e.g. collecting information about how you use our Services to optimize the design and placement of certain features;'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Legal compliance:',
	                    _react2.default.createElement('br', null),
	                    'We need to use and disclose personal data in certain ways to comply with our legal obligations.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Consent:',
	                    _react2.default.createElement('br', null),
	                    'Where required by law, and in some other cases, we handle personal data on the basis of your implied or express consent.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Children'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Our Services are for users age 16 and over and we do not knowingly collect personal information from children under the age of 16. If you are a parent or guardian of a child under the age of 16 and believe he or she has disclosed personal information to us please contact us at gdpr@the-grid.org'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Unsolicited information'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You may provide us with ideas for new products or modifications to existing products, and other unsolicited submissions (collectively, \u201CUnsolicited Information\u201D). All Unsolicited Information shall be deemed to be non-confidential and we shall be free to reproduce, use, disclose, and distribute such Unsolicited Information to others without limitation or attribution.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Links to other web sites'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'This Privacy Policy applies only to the Services. The Services may contain links to other web sites not operated or controlled by us (the \u201CThird Party Sites\u201D). The policies and procedures we described here do not apply to the Third Party Sites. The links from the Services do not imply that we endorse or have reviewed the Third Party Sites.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Trusted third parties'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Trusted third parties may after a vetting process access status information on your account through an authenticated API.',
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Opt-out'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Information that is available for vetted third parties without action on your part is your account status on the-grid.org (for example "verified" or "moderator"). It is possible to choose not to share this information, but keep in mind that sharing is caring in this case, and helps many Resistance resources be even more helpful.'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Opt-in'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Trusted (and vetted) third parties may ask for more detailed sharing of information, but this requires explicit action (OAUTH or sharing of API keys) on your part and is nothing that will happen without your consent.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Your data rights and choices'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We believe that users should be treated equally no matter where they are, and so we are making the following options to control your data available to all users, regardless of their location. You can update certain information by accessing your profile via \u201CSettings.\u201D You can also unsubscribe from certain emails by clicking the \u201Cunsubscribe\u201D link they contain.'
	            ),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'How do I correct, update, or delete the personal data you have about me?'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'In addition to the functionality available through the \u201CSettings\u201D of TheGrid, in which you can correct, update, or delete certain personal data, you can also request other modifications from us directly. Please write us at gdpr@the-grid.org with the words \u201CPersonal Data Request\u201D in the subject or body of your message, along with an explanation of what data subject right you are seeking to exercise. For your protection, we may take steps to verify identity before responding to your request.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Changes to this privacy policy'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We reserve the right to update or modify this Privacy Policy at any time and from time to time without prior notice. Please review this policy periodically, and especially before you provide any information. Your continued use of the Services after any changes or revisions to this Privacy Policy shall indicate your agreement with the terms of such revised Privacy Policy.'
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Contacting us'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Please also feel free to contact us if you have any questions about this Privacy Policy or the information practices of the Services. You may contact us as follows: contact@the-grid.org or gdpr@the-grid.org'
	            )
	        )
	    );
	};
	
	exports.default = PrivacyPolicyPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-94d5b9581ce65f2a0380.js